import { Component, Inject } from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatButton } from '@angular/material/button'
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field'
import { MatInput, MatInputModule } from '@angular/material/input'

// Motivo é obrigatório na API (recusar-operador) — mesmo texto vai pra todas as OS
// selecionadas quando é um lote.
@Component({
  selector: 'modal-recusar-operador',
  standalone: true,
  imports: [ReactiveFormsModule, MatButton, MatFormField, MatInput, MatLabel, MatFormFieldModule, MatInputModule],
  templateUrl: './modal-recusar-operador.component.html',
})
export class ModalRecusarOperadorComponent {
  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ModalRecusarOperadorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { count: number },
  ) {
    this.form = this.fb.group({
      motivo: ['', [Validators.required]],
    })
  }

  form: FormGroup

  confirm(): void {
    if (this.form.invalid) return
    this.dialogRef.close(this.form.value.motivo)
  }

  cancel(): void {
    this.dialogRef.close(null)
  }
}
